import axios from "axios";

// All KYC verification now goes through the sales backend instead of calling
// Surepass directly. The Surepass token used to live in this file as
// REACT_APP_SUREPASS_TOKEN, which meant it shipped inside the production JS
// bundle and could be read out of devtools by anyone who opened the app.
//
// The backend proxy replays Surepass's status code and response body verbatim,
// so the shapes these functions resolve and reject with are unchanged: callers
// keep reading resp.data.message_code and resp.data.data.full_name. See
// routes/surepass.js in SALES-APP-BACKEND-NODE-API.

// The sales backend base URL — the same variable this app already uses for
// every other backend call. The value normally carries a trailing slash; the
// trim keeps this correct whether or not it is present.
const API_ROOT = String(process.env.REACT_APP_PAYMENT_LINK_URL || "").replace(/\/+$/, "");
const SUREPASS_BASE = `${API_ROOT}/api/surepass`;

async function getPAN_cardDetails(panCardNumber) {
	const response = await axios
		.post(`${SUREPASS_BASE}/pan`, { id_number: panCardNumber })
		// Deliberately preserved: this swallows the rejection and resolves with
		// the error object instead. BookingForm and AgreementKYC both read
		// resp.data.message_code straight off the result and never attach a
		// .catch of their own, so removing this would change how a failed PAN
		// lookup behaves at every call site.
		.catch((error) => {
			return error;
		});
	return response;
}

async function getAadharCardDetails(aadharNumber) {
	// less_info is not sent, matching the existing behaviour here. The backend
	// forwards it only when a caller provides it.
	const response = await axios.post(`${SUREPASS_BASE}/aadhaar-validation`, {
		id_number: aadharNumber,
	});

	return response;
}

async function getBankAccDetails(bankObj) {
	// ifsc_details is not sent, matching the existing behaviour here.
	const response = await axios.post(`${SUREPASS_BASE}/bank-verification`, {
		id_number: bankObj.accountNo,
		ifsc: bankObj.ifscCode,
	});

	return response;
}

export { getPAN_cardDetails, getAadharCardDetails, getBankAccDetails };
